import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CrewDetailView } from '@/components/CrewDetailView'

const crewDetailSearchSchema = z.object({
  tab: z.enum(['overview', 'documents', 'flights']).optional().default('overview'),
  documentId: z.string().optional(),
})

export const Route = createFileRoute('/_auth/operations/crew-directory/$crewId')({
  component: RouteComponent,
  validateSearch: crewDetailSearchSchema,
})

function RouteComponent() {
  const { crewId } = Route.useParams()
  const { tab, documentId } = Route.useSearch()

  return (
    <CrewDetailView
      crewId={crewId}
      initialTab={tab}
      initialDocumentId={documentId}
      backTo="/operations/crew-directory"
    />
  )
}
